module.exports = __webpack_public_path__ + "static/media/boar-tusks.bb1e24d5.svg";